import { render, staticRenderFns } from "./selectMarca.vue?vue&type=template&id=c00fe192"
import script from "./selectMarca.vue?vue&type=script&lang=ts"
export * from "./selectMarca.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports